import React, { useMemo } from "react";
import {
  Color,
  Cartesian3,
  UrlTemplateImageryProvider,
  BingMapsImageryProvider,
  BingMapsStyle,
} from "cesium";
import {
  Viewer,
  Scene,
  Camera,
  CameraFlyTo,
  Globe,
  ImageryLayer,
} from "resium";
import { useSelector } from "react-redux";

import styles from "./index.module.less";

const bgColor = Color.fromBytes(35, 35, 35, 0.5);
const token = "41222ba4e90e51b5c90d08c329a55faa";
const tdtUrl = "https://t{s}.tianditu.gov.cn/";
const subdomains = ["0", "1", "2", "3", "4", "5", "6", "7"];

const ArcticViewer = ({ children }) => {
  const mode = useSelector((state) => state.panel.mode);
  const destination =
    mode === "planning"
      ? Cartesian3.fromDegrees(180.1, 90.1, 11000000)
      : Cartesian3.fromDegrees(98.78, 79.38, 1000000);

  // const imageryProvider = useMemo(
  //   () =>
  //     new UrlTemplateImageryProvider({
  //       url: tdtUrl + "DataServer?T=img_w&x={x}&y={y}&l={z}&tk=" + token,
  //       subdomains: subdomains,
  //       maximumLevel: 18,
  //     }),
  //   []
  // );

  const imageryProvider = useMemo(
    () =>
      new BingMapsImageryProvider({
        url: "https://dev.virtualearth.net",
        key: "Ahv1KDJwbpJl4V8zklaRXcoueWXoNLo16osJiU4Zk07vc-VNNzJ0gB81TZyPqNFz",
        mapStyle: BingMapsStyle.AERIAL,
      }),
    []
  );
  const labelImageryProvider = useMemo(
    () =>
      new UrlTemplateImageryProvider({
        url: tdtUrl + "DataServer?T=cia_w&x={x}&y={y}&l={z}&tk=" + token,
        subdomains: subdomains,
        maximumLevel: 18,
      }),
    []
  );

  const boundaryImageryProvider = useMemo(
    () =>
      new UrlTemplateImageryProvider({
        url: tdtUrl + "DataServer?T=ibo_w&x={x}&y={y}&l={z}&tk=" + token,
        subdomains: subdomains,
        maximumLevel: 18,
      }),
    []
  );
  return (
    <Viewer
      id="arctic-viewer"
      full={true}
      animation={false}
      timeline={false}
      sceneModePicker={false}
      baseLayerPicker={false}
      geocoder={false}
      scene3DOnly={true}
      navigationHelpButton={false}
      homeButton={false}
      infoBox={false}
      showRenderLoopErrors={false}
      skyBox={false}
      fullscreenButton={false}
      selectionIndicator={false}
      imageryProvider={imageryProvider}
      className={styles.myCesium}
    >
      <Scene backgroundColor={bgColor} />
      <ImageryLayer imageryProvider={labelImageryProvider} />
      <ImageryLayer imageryProvider={boundaryImageryProvider} />
      <Globe />
      <Camera defaultZoomAmount={0} />
      <CameraFlyTo duration={5} destination={destination} />
      {children}
    </Viewer>
  );
};

export default ArcticViewer;
